import { Fragment, useEffect, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";

import useDialogStore from "@store/useDialogStore";
import { ANIMATION_DURATION_IN_MS } from "@config/constants";
import { useBlurOnDialogClose } from "./hooks/useBlurOnDialogClose";

export function GlobalDialog() {
  const { isOpen, body, closeDialog, options } = useDialogStore();
  const initialFocusRef = useRef(null);
  const dialog = useRef<HTMLDivElement>(null);

  useBlurOnDialogClose(isOpen);

  useEffect(() => {
    if (dialog?.current) {
      dialog.current.classList.remove("dialog-open");
      dialog.current.style.paddingRight = "0";
    }
  }, []);

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        onClose={options?.disableOutsideClick ? () => {} : closeDialog}
        className="relative z-50"
        initialFocus={initialFocusRef}
      >
        {/* Overlay */}
        <Transition.Child
          as={Fragment}
          enter={`ease-out duration-${ANIMATION_DURATION_IN_MS}`}
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave={`ease-in duration-${ANIMATION_DURATION_IN_MS}`}
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black-500/20 dark:bg-black-500/50" />
        </Transition.Child>

        <div ref={dialog} className="fixed inset-0 overflow-y-auto">
          {body}
        </div>
      </Dialog>
    </Transition>
  );
}
